import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  IMultiPreferenceRowProps,
  MultiPreferenceRow,
} from './MultiPreferenceRow';

export interface IMultiPreferenceSortableRowProps
  extends IMultiPreferenceRowProps {
  id: string;
}

export function MultiPreferenceSortableRow(
  props: Readonly<IMultiPreferenceSortableRowProps>,
) {
  const { id, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition, active } =
    useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
    >
      <MultiPreferenceRow {...otherProps} isSpaceForDrag={id === active?.id} />
    </div>
  );
}
